

import React, { memo } from 'react';
import { Dropdown, Button } from '../../../../../../ui-kit';
import '../styles/_caption.scss';














function Caption({
  defaultLanguage,
  onDelete,
  onChange,
  label,
  selectedCaptions,
  disabled,
  type,
  CAPTIONS
}) {
  const currentCaptions = CAPTIONS(type);

  const captionOptions = currentCaptions.
  filter((caption) => !selectedCaptions.includes(caption.value));
  return (
    <div className="caption">
      <Dropdown
        options={captionOptions}
        onChange={onChange}
        defaultValue={
        defaultLanguage && currentCaptions.find(
          (caption) => caption.value === defaultLanguage.value
        )}

        placeholder="Select a caption"
        label={label}
        hideSeparators
        showSelectedSuffix
        disabled={disabled}
        type="BUTTON" />

      {
      onDelete && !disabled ?
      <Button prefix="trash" onClick={onDelete} type="TERTIARY" /> :
      null}

    </div>);

}

export default memo(Caption);